// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../../utils/Utils.bs.js");
let IconV5 = require("./IconV5.bs.js");
let Tooltip = require("./Tooltip.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let AreasCriteria_area_graphql = require("../../../__generated__/AreasCriteria_area_graphql.bs.js");

let convertFragment = AreasCriteria_area_graphql.Internal.convertFragment;

function AreasCriteria(props) {
  let __icon = props.icon;
  let icon = __icon !== undefined ? Primitive_option.valFromOption(__icon) : "location";
  let areas = RescriptRelay_Fragment.useFragment(AreasCriteria_area_graphql.node, convertFragment, props.areas);
  let __x = areas.map(area => JsxRuntime.jsx(Tooltip.make, {
    label: area.label,
    children: JsxRuntime.jsx("span", {
      children: area.name,
      className: "md:inline-block md:underline md:decoration-dotted md:decoration-zinc-400"
    })
  }));
  return JsxRuntime.jsxs("div", {
    children: [
      Stdlib_Option.getOr(Stdlib_Option.map(icon, icon => JsxRuntime.jsx(IconV5.make, {
        icon: icon,
        className: "text-zinc-400"
      })), null),
      JsxRuntime.jsx("div", {
        children: Utils.$$Array.pseudoJoin(", ", undefined, __x),
        className: "text-zinc-700"
      })
    ],
    className: "flex items-start gap-2"
  });
}

let make = AreasCriteria;

exports.make = make;
/* Utils Not a pure module */
